import { Grid } from "@mui/material";
import AdminCard from "../components/Admin/AdminCard";
import AdminUmmIAImg from "../components/Admin/img/AdminUmmIA.png";
import HeaderCategoria from "../components/UmmIACategories/HeaderCategoria";
import { getAdminCards } from "../data/adminCards";
import { useAuthContext } from "../hooks/Auth";
import { iUser } from "../interfaces/Auth/iUser";

export const AdminPage = () => {
  const { user, canAccess } = useAuthContext();
  const adminCards = getAdminCards(user as iUser).filter(
    (item) => !item.permission || canAccess(item.permission)
  );
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="Admin UmmIA"
        descripcion="Centraliza y simplifica la gestión de tus operaciones educativas y optimiza tus procesos a medida"
        img={AdminUmmIAImg}
        alt="Imagen Admin UmmIA"
        primaryColor="#336B87"
        secondaryColor="#FCFCFC"
        thirdColor="#89aaba"
        secondPercentage="40"
      />

      {/* Contenedor de cartas */}
      <Grid container spacing={{ xs: 4, xl: 10 }} sx={{ px: { xs: 2, md: 4 } }}>
        {adminCards.map((app, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
              <AdminCard
                img={app.image}
                nombre={app.title}
                route={app.route}
                descripcion={app.description}
                alt={app.alt}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
